export function useCurrentLegalText() {
  const routeParams = useRouteParams();

  const slug = computed(() => routeParams.legalTextSlug);

  return useFetchLegalTextBySlug(slug);
}
